import React from 'react';
import {LineDiv, SectionDiv, Text} from "../../go-aroung/design";

const DataSelection = ({selectedDate, setSelectedDate, dates}) => {
    function changeData(event){
        let date=event.currentTarget.id;
        setSelectedDate(date)
    }
    // console.log(dates)
    return (

        <SectionDiv
            $visible={true}
            $clickable={true}
        >
            {dates.map((date) => {
                const selected = selectedDate === date;

                return (
                    <LineDiv
                        key={date}
                        id={date}
                        $selected={selected}
                        onClick={changeData}
                    >
                        <input
                            type="checkbox"
                            checked={selected}
                            readOnly
                            tabIndex={-1}
                        />

                        <Text>{date}</Text>
                    </LineDiv>
                );
            })}
        </SectionDiv>
    );
};

export default DataSelection;